export default {
  //登录
  Chinese:"Ch",
  English:"En",
  Overseas_warehouse_system:"Overseas warehouse system",
  UserAccount:"User account",
  password:"password",
  RememberPassword:"Remember the password",
  ForgotPassword:"Forgot password",
  RegisterAccount:"Register an account",
  login:"login",
  Please_enter_a_user_account:"The user account number was not entered",
  Please_enter_the_user_password:"The password was not entered",
  SignIn:"Sign in",
  LoginSuccessful:"Login successful",
}
